import React, { createRef, FC, useState } from 'react';

// Shared UI Library Components
import { DiscardModal, TabsElement } from '@ppmcore/seven-ppm-core-shared-components-react';

// Styles
import './counsellor-attributes.scss';

// Components
import { CountriesTab, TCountriesTabRef } from '../countries-tab/countries-tab';
import { LanguagesTab, TLanguagesTabRef } from '../languages-tab/languages-tab';
import { SpecialtySpecialisationsTab } from '../specialty-specialisations-tab/specialty-specialisations-tab';

const defaultActiveKey = 'countries';

type TTabKeys = 'countries' | 'languages' | 'specialties-and-specialisations';

type TCounsellorAttributesProps = {};

export const CounsellorAttributes: FC<TCounsellorAttributesProps> = (
  {}: TCounsellorAttributesProps
) => {
  const countriesRef = createRef<TCountriesTabRef>();
  const languagesRef = createRef<TLanguagesTabRef>();

  const [discardOpen, setDiscardOpen] = useState<boolean>(false);
  const [activeKey, setActiveKey] = useState<TTabKeys>(defaultActiveKey);
  const [nextKey, setNextKey] = useState<TTabKeys | null>(null);

  const toggleDiscardModal = (): void => {
    setDiscardOpen(!discardOpen);
  }

  const resetRefState = (): void => {
    if (activeKey === 'specialties-and-specialisations') return;
    if (activeKey === 'countries') {
      countriesRef.current?.resetState();
      return;
    }
    if (activeKey === 'languages') {
      languagesRef.current?.resetState();
      return;
    }
  }

  const onDiscardChangesHandler = (state: boolean): void => {
    if (state) {
      toggleDiscardModal();
      resetRefState();
      setActiveKey(nextKey ?? defaultActiveKey);
      setNextKey(null);
      return;
    }
    toggleDiscardModal();
  }

  const onTabClickHandler = (key: string, event: any) => {
    event.preventDefault();
    setNextKey(key as TTabKeys);

    if (countriesRef.current?.isHasChanges() || languagesRef.current?.isHasChanges()) {
      toggleDiscardModal();
      return;
    }

    setActiveKey(key as TTabKeys);
  }

  return (
    <div className="counsellor-attributes">

      <DiscardModal
        open={ discardOpen }
        onCancel={ onDiscardChangesHandler }
        title={ 'Are you sure you want to discard changes?' }
      />

      <div className="counsellor-attributes--header">
        <div className="header-title">
          Consultant Attributes
        </div>
      </div>

      <div className="counsellor-attributes--body">
        <TabsElement activeKey={ activeKey } onTabClick={ onTabClickHandler } items={ [
          {
            key: 'countries',
            label: 'Countries',
            children: <CountriesTab ref={ countriesRef }/>,
          },
          {
            key: 'languages',
            label: 'Languages',
            children: <LanguagesTab ref={ languagesRef }/>,
          },
          {
            key: 'specialties-and-specialisations',
            label: 'Specialties and Specialisations',
            children: <SpecialtySpecialisationsTab/>,
          },
        ] }/>
      </div>
    </div>
  );
}
